import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2StarterPackageBoughtDialogProperties extends BasicDialogProperties {
    constructor() {
        super();
    }
}
